var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V42H42V0H0ZM22.5 32.625C22.5 36.7134 20.085 38.7066 16.5891 38.7066C13.4316 38.7066 11.5988 37.0716 10.6688 35.0981L13.8825 33.1528C14.5022 34.2525 14.9728 35.1825 16.3256 35.1825C17.4506 35.1825 18.375 34.6753 18.375 32.7019V19.5H22.5V32.625ZM31.8141 38.6128C28.1494 38.6128 25.7813 36.9591 24.6253 34.6753L27.8438 32.8125C28.6875 34.1944 29.7891 35.115 31.7344 35.115C33.3694 35.115 34.3191 34.3913 34.3191 33.2634C34.3191 31.9106 33.3413 31.4316 31.5366 30.6384L30.5503 30.2147C27.7022 29.0034 25.8141 27.4809 25.8141 24.2663C25.8141 21.3066 28.0687 19.1447 31.5928 19.1447C34.1025 19.1447 35.9053 19.9247 37.2038 22.2084L34.125 24.1875C33.4481 22.9753 32.7188 22.5 31.5881 22.5C30.4322 22.5 29.6991 23.2331 29.6991 24.1875C29.6991 25.3716 30.4322 25.8506 32.1234 26.5837L33.1097 27.0066C36.465 28.4447 38.3541 29.9128 38.3541 33.2091C38.355 36.7622 35.5641 38.6128 31.8141 38.6128Z",
    fill: "url(#paint0_linear_5_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_65",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.58b40ce8c7fb61024facf504814fb4aa.svg";
export { ForwardRef as ReactComponent };